export default __webpack_public_path__ + "static/media/RecipesPRO.4def2ac9.jpg";